export default {
    Email: 'E-mail',
    ConfirmEmail: 'Bevestig E-mail',
    Password: 'Wachtwoord',
    Verificationcode: 'Verificatie code',
    AlreadyhaveaHitPawaccountLogin: 'Heeft u al een HitPaw account ? Inloggen',
    ByproceedingyouagreetoourServicesofUseandPrivacyPolicy1:
        'Door u aan te melden, gaat u akkoord met onze Gebruiksvoorwaarden en Privacy Policy',
    ByproceedingyouagreetoourServicesofUseandPrivacyPolicy2:
        'Door verder te gaan, gaat u akkoord met onze Gebruiksvoorwaarden en Privacybeleid',
    Byproceedingyouagreetoour: 'Door verder te gaan, gaat u akkoord met onze ',
    ServicesofUse: 'Gebruiksvoorwaarden',
    and: ' en ',
    PrivacyPolicy: 'Privacybeleid',
    last: '.',
    TheEmailformatisincorrect: 'Het e-mail formaat is onjuist',
    Pleaseenterthesameemailinbothfields:
        'Gelieve dezelfde e-mail in te vullen in beide velden.',
    Thepasswordmustbe850charactersandcontainatleasttwocategoriesamongthefollowingnumberletterorspecialcharacter:
        'Het wachtwoord moet 8-50 tekens lang zijn en ten minste twee van de volgende categorieën bevatten: cijfer, letter of speciaal teken.',
    Incorrectverificationcode: 'Onjuiste verificatie code',
    ThisEmailhasbeenregisteredpleasechooseanother:
        'Dit E-mail is al geregistreerd, kies een ander.',
    Cannotbeemptyhere: 'Kan hier niet leeg zijn.',
    Rememberme: 'Onthoud mij',
    ForgotPassword1: 'Wachtwoord vergeten?',
    NotaregistereduseryetSignUp: 'Nog geen geregistreerde gebruiker? Aanmelden',
    Notaregistereduseryet1: 'Nog geen geregistreerde gebruiker? ',
    Notaregistereduseryet2: 'Aanmelden',
    NoaccountfoundwiththatEmailaddress: 'Geen account gevonden met dat e-mail adres',
    YourEmailaddressorpasswordwasincorrectPleasetryagain:
        'Uw e-mailadres of wachtwoord is onjuist. Probeer het opnieuw.',
    ForgotPassword2: 'Wachtwoord vergeten',
    GetVerificationCode: 'Verificatiecode aanvragen',
    VerifyEmail: 'Verifieer e-mail',
    Ithasbeensenttoyourmailboxpleasecheckit:
        'Het is verzonden naar uw mailbox, verifieer het alstublieft',
    PleaseinputEmailaddress: 'Gelieve een e-mail adres in te voeren',
    TheEmailisnotregistered: 'De e-mail is niet geregistreerd',
    Invalidverificationcodepleasereenterthecorrectone:
        'Ongeldige verificatie code, gelieve de juiste opnieuw in te voeren',
    Resetpassword: 'Wachtwoord opnieuw instellen',
    Emailaddressverificationsucceeded: 'E-mail adres verificatie geslaagd',
    Pleaseresetyourpassword: 'Resetten uw wachtwoord',
    Enteranewpassword: 'Voer een nieuw wachtwoord in',
    Confirm: 'Bevestig',
    Newpasswordshouldbe850characterslongcomposedoflettersornumbersoramixtureoflettersnumbers:
        'Nieuw wachtwoord moet 8-50 tekens lang zijn, bestaande uit letters of cijfers of een combinatie van letters + cijfers',
    Passwordresetsuccessfully: 'Wachtwoord succesvol gereset',
    Name: 'Naam',
    GetCode: 'Code ophalen',
    Loginsuccessful: 'Inloggen gelukt',
    Loginfailed: 'Inloggen mislukt',
    Signupsuccessful: 'Registreren gelukt',
    Signupfailed: 'Aanmelden mislukt',
    Getpassword: 'Wachtwoord opvragen',
    Authorizationhasexpiredpleaseloginagain:
        'Autorisatie is verlopen, gelieve opnieuw in te loggen.',
    Sorrysomethingwentwrongpleasetryagainlater:
        'Sorry, er is iets misgegaan, probeer het later nog eens.',
    Toomanysamerequestsweremadeinashortperiodoftimepleasetryagainlater:
        'Er zijn te veel dezelfde verzoeken gedaan in een korte tijd, probeer het later nog eens.',
    Couldntfindyouraccountorthepasswordisincorrect:
        'Kon uw account niet vinden, of het wachtwoord is onjuist.',
    Youaretryingtoaccessapaidfunctionpleasesubscribefirst:
        'U probeert toegang te krijgen tot een betaalde functie, schrijf u eerst in.',
    Accessdeniedfortheunauthorizedrequest: 'Toegang geweigerd voor het ongeoorloofde verzoek.',
    Alreadyhaveaccount: 'Heb je al rekening?',
    SignUpwithemail: 'Aanmelden met e-mail',
    Securityverification: 'Veiligheidscontrole',
    Pleaseenterthecorrectemailaddress: 'Vul het juiste e-mailadres in!',
    PleaseInputverificationCode: 'Voer de verificatiecode in!',
    Pleaseenterthesamepasswordinbothfields: 'Voer in beide velden hetzelfde wachtwoord in!',
    or: 'of',
    ThenewpasswordyouenteredisthesameasyouroldpasswordEnteradifferentpassword:
        'Het nieuwe wachtwoord dat u heeft ingevoerd is hetzelfde als uw oude wachtwoord. Voer een ander wachtwoord in',
    YourpasswordwasincorrectPleasetryagain: 'Uw wachtwoord was onjuist. Probeer het opnieuw.',
    reg400: 'Sorry, er is iets misgegaan, probeer het later nog eens.',
    reg400223: 'De e-mail en code komen niet overeen, controleer',
    reg400224: 'Token is verlopen',
    500: 'Server side fout!',
    Afewsecondsaway: 'Een paar seconden verwijderd',
    ContinuewithGoogle: 'Doorgaan met Google',
    ContinuewithEmail: 'Doorgaan met e-mail',
    LoginwithEmail: 'Log in met e-mail',
    Usemorethan8charactersandmixlettersnumbersandsymbols:
        'Gebruik meer dan 8 tekens met een mix van letters, cijfers en symbolen (ondersteunende symbolen:@$!%*#_~?&^)',
    ConfirmPassword: 'Bevestig wachtwoord',
    Pleaseloginwithemail: 'Gelieve in te loggen met E-mail',
    youraccount: 'Uw account',
    alreadyexiststoensurethesecuritypleaseverifyitfirst:
        'bestaat al, om de veiligheid van uw account te verzekeren, gelieve eerst de verificatie te voltooien.',
    Login: 'Inloggen',
    exceed6Times: 'Uw proefperiode is vandaag afgelopen. Upgrade naar Pro om toegang te krijgen tot alle premiumfuncties.',
    exceed20M: 'De bestandsgrootte voor gratis accounts mag niet groter zijn dan 20 MB, upgrade naar Pro om toegang te krijgen tot alle premiumfuncties.'
}